module.exports = __webpack_public_path__ + "static/media/facebook-square.cfdb2f96.svg";